import React, { useContext, useRef, useState } from "react";
import { axiosUrl } from "../../api/axios";
import { UserContext } from "../../App";
import "../../styles/layout.scss";
// import WithdrawalToken from "./WithdrawalToken";

const WithdrawComp = (props) => {
  const [tokenComp, setTokenComp] = useState(false);
  const [tokenCode, setTokenCode] = useState("");
  const [inputValue, setInputValue] = useState("");
  const { userData } = useContext(UserContext);
  const [cryptoType, setCryptoType] = useState("");
  const [errMsg, setErrMsg] = useState("");
  const errRef = useRef();
  const [tokenErr, setTokenErr] = useState(false);

  const closeModal = (e) => {
    props.setWithdrawComp(false);
    setInputValue("");
    setCryptoType("");
  };

  const handleChnage = (e) => {
    e.preventDefault();
    setInputValue(e.target.value);
  };
  const handleChnageSelect = (e) => {
    e.preventDefault();
    setCryptoType(e.target.value);
  };

  const checkWithdrawal = (e) => {
    e.preventDefault();

    if (userData.user.verification === false) {
      setErrMsg("ACCOUNT MUST BE VERIFIED, CONTACT SUPPORT FOR VERIFICATION.");
      return;
    }

    if (inputValue > userData.user.profit) {
      setErrMsg("Amount not available for withdrawal");
      errRef.current.focus();
      setInputValue("");
      return;
    } else if (inputValue <= 0) {
      setErrMsg("Amount not available for withdrawal");
      errRef.current.focus();
      setInputValue("");
      return;
    } else if (!cryptoType) {
      setErrMsg("Please select a wallet");
      return;
    } else {
      setTokenComp(true);
    }
  };

  const newWithdrawal = async (e) => {
    e.preventDefault();

    console.log("working here");
    try {
      const res = await axiosUrl.post("/token", {
        token: tokenCode,
      });

      if (res.status !== 200) {
        setTokenErr(true);
        return;
      }

      const newTransaction = {
        userId: `${userData.user.id}`,
        user: `${userData.user.firstName} ${userData.user.lastName}`,
        type: "Withdrawal",
        amount: inputValue,
        mode: cryptoType,
        status: false,
      };

      axiosUrl.post("/transactions", newTransaction);

      alert("withdrawal request sent");
      closeModal();
      window.location.href = "/dashboard/withdraw";
    } catch (error) {
      setTokenErr(true);
      console.log("token error", error);
    }
  };

  return (
    <div className="withdraw-modal">
      <div className="inner">
        <div className="withdraw-title ">
          <h6 className="title">Request For Withdrawal</h6>
          <i className="fas fa-times" onClick={closeModal}></i>
        </div>

        <div className={`${errMsg ? "d-flex" : "d-none"} error-message`}>
          <i className="fas fa-exclamation-triangle mx-3"></i>
          <p className="fw-bold">{errMsg}</p>
        </div>

        <form onSubmit={newWithdrawal}>
          <div className="balances">
            <p className="sharp-text">
              Total Balance: <span>${userData.user.balance}</span>
            </p>
            <p className="sharp-text">
              Withdrawable Balance: <span>${userData.user.profit}</span>
            </p>
          </div>

          <div className="withdraw-form-group">
            <label htmlFor="withdraw-amount-input" className="sharp-text">
              Enter Amount:
            </label>
            <input
              name="withdraw-amount-input"
              type="number"
              placeholder="$"
              value={inputValue}
              onChange={handleChnage}
              required
              ref={errRef}
            />
          </div>
          <div className="withdraw-form-group">
            <label htmlFor="select-wallet" className="sharp-text">
              Select Wallet:
            </label>
            <select
              name="select wallet"
              id=""
              placeholder="Select a Wallet"
              value={cryptoType}
              onChange={handleChnageSelect}
              onFocus={() => setErrMsg(false)}
            >
              <option value="">Choose Wallet</option>
              <option value="Bitcoin">Bitcoin</option>
              <option value="Ethereum">Ethereum</option>
              <option value="Dogecoin">Dogecoin</option>
              <option value="USDT">USDT</option>
            </select>
          </div>

          <div className="sumbit-btn">
            <button
              onClick={checkWithdrawal}
              className="btn btn-primary rounded"
            >
              Withdraw
            </button>
          </div>
        </form>
        {tokenComp && (
          <div className="token-wrapper">
            <div className="token">
              <h3 className="token-title">Withdrawal Token</h3>
              <i
                className="fas fa-times"
                onClick={() => {
                  setTokenComp(false);
                  setTokenCode("");
                }}
              ></i>
              <div className="token-input" onSubmit={newWithdrawal}>
                <input
                  type="text"
                  placeholder="Token"
                  value={tokenCode}
                  onChange={(e) => setTokenCode(e.target.value)}
                  required
                  onFocus={() => {
                    setTokenErr(false);
                    setTokenCode("");
                  }}
                />
                <button onClick={newWithdrawal} className="btn">
                  Submit
                </button>
              </div>
            </div>

            {tokenErr && <p className="info">Invalid Token</p>}
            <p className="info">
              Contact Support to get your Withdrawal token!!!!!
            </p>

            <div className="btns">
              <button className="btn">Contact Support</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default WithdrawComp;
